/* eslint-disable no-undef */
import React from 'react';
import Link from 'next/link';
import ModalVideo from 'react-modal-video';
import { connect } from 'react-redux';

import SubscribeToMailList from '../Home/SubscribeToMailList';
import config from '../../config';
import getFooterHyperLinksContent from '../../redux/actions/v2/footer-hyper-links-actions';
import { formatPrismicUrl, getTarget, isAppUrl, isInternalRouteUrl } from '../../utils/url';

const { appHost } = config;
class HomePageFooter extends React.Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            submitting: false,
        };

        this.openModal = this.openModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    componentDidMount() {
        if (!this.props.footerHyperLinks.loaded && !this.props.footerHyperLinks.loading) {
            this.props.getFooterHyperLinksContent();
        }
    }

    onKeyPress(event) {
        if (event.key === 'Enter' && event.target.type !== 'submit' && event.target.type !== 'button') {
            event.preventDefault();
        }
    }

    async handleSubmit(formValues) {
        const { apiHost } = config;
        this.setState({ submitting: true });
        fetch(`${apiHost}/v1/mailinglist/global`, {
            method: 'post',
            body: JSON.stringify(formValues),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                if (data.error) {
                    throw Error;
                }
                analytics.identify({
                    email: formValues.email,

                });
                this.setState({ submitting: false });
                this.props.showSuccess('Thank you for subscribing to UTR!');
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
                console.log('error', error);
                throw Error;
            });
    }

    openModal(video) {
        this.setState({ isOpen: video });
    }

    render() {
        const { footerHyperLinks } = this.props;

        return (
            <footer className={`footer`}>
                <div className="container">
                    <div className={`row`}>
                        <div className={`col-12`}>
                            <div className="logo-wrapper">
                                <div className="footer-logo">
                                    <img src="/img/v2/ut-logo2.svg" />
                                </div>
                                <div className="app-store-logo">
                                    <a href={config.links.appStoreUrl} target="_blank" rel="noopener noreferrer">
                                        <img src="/img/app-store-badge.svg" />
                                    </a>
                                </div>
                                <div className="google-store-logo">
                                    <a href={config.links.googleStoreUrl}>
                                        <img alt="Get it on Google Play" src="/img/Google_Play_Store_badge_EN.svg" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`row bb pb120`}>
                        {footerHyperLinks.content.length > 0 && (
                            <>
                                {footerHyperLinks.content.map((linkSection, i) => (
                                    <div className={`footer-links col-12 col-md-2`} key={`link-section-${i}`}>
                                        <div className={`footer-link-header`}>
                                            {linkSection.tab_title}
                                        </div>
                                        {linkSection.repeatable?.length && (
                                            <ul>
                                                {linkSection.repeatable.map((link, j) => (
                                                    <li key={`hyper-link-${linkSection.tab_title}-${j}`}>
                                                        {isInternalRouteUrl(link.menu_tab_item_url) && (
                                                            <Link href={link.menu_tab_item_url}>
                                                                <a className="text-gray">{link.menu_tab_item_name}</a>
                                                            </Link>
                                                        )}
                                                        {!isInternalRouteUrl(link.menu_tab_item_url) && (
                                                            <a
                                                                href={formatPrismicUrl(link.menu_tab_item_url)}
                                                                target={getTarget(link.menu_tab_item_url)}
                                                                rel="noopener noreferrer"
                                                                className="text-gray"
                                                            >
                                                                {link.menu_tab_item_name}
                                                            </a>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ))}
                            </>
                        )}
                        <div className={`footer-links col-12 col-md-4`}>
                            <div className={`footer-link-header`}>
                                Sign up to get the latest
                            </div>
                            <SubscribeToMailList
                                field={'email'}
                                id={'email'}
                                handleSubmit={this.handleSubmit}
                                buttonLabel={'SUBMIT'}
                                placeHolder={'Your Email'}
                                buttonStyle={`btn btn-primary btn-sm`}
                                submitting={this.state.submitting}
                                hiddenLabel={true}
                            />
                            {/* <hr /> */}
                            <div className="d-flex icons">
                                <a href="https://www.youtube.com/c/myutr" target="_blank" rel="noopener noreferrer">
                                    <div className={`footer-icon youtube`} />
                                </a>
                                <a href="https://facebook.com/UniversalTennis" target="_blank" rel="noopener noreferrer">
                                    <div className={`footer-icon facebook`} />
                                </a>
                                <a href="https://www.instagram.com/universaltennis/" target="_blank" rel="noopener noreferrer">
                                    <div className={`footer-icon ig`} />
                                </a>
                                <a href="https://twitter.com/UniversalTennis" target="_blank" rel="noopener noreferrer">
                                    <div className={`footer-icon twitter`} />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-10">
                            <div className="d-flex text-small links">
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        &copy; Copyright 2022 Universal Tennis
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video1'} videoId="u-uG5M3bULk" autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                    <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video2'} videoId="maJS-0kOwSo" autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                </div>
            </footer>
        );
    }
}

const mapStateToProps = ({ footerHyperLinks }) => {
    return { footerHyperLinks };
};

function mapDispatchToProps(dispatch) {
    return {
        showSuccess: (msg) => dispatch({ type: 'SHOW_ERROR_POPUP', message: msg, custom: true, cta: 'OK' }),
        getFooterHyperLinksContent: () => dispatch(getFooterHyperLinksContent()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageFooter);
